export const stockEquipmentKeys = {
    all: ['stock-equipment'] as const,
    assignable: (jobId: string, rentalAssetTypeId: string) =>
        [...stockEquipmentKeys.all, 'assignable', jobId, rentalAssetTypeId] as const,
}
